import { css, styled } from 'styled-components';
import icon from '../../assets/icons/magnifying-glass.png';
import { HOST } from 'shared/consts/https';
import { MAIN_COLOR, SHADOW_COLOR } from 'shared/consts';

interface InputProps {
	$hide: boolean;
}

export const Input = styled.input<InputProps>`
	border-width: 1px;
	border-radius: 20px;
	height: 37px;
	border: 1px solid white;
	padding-left: 40px;
	font-size: 17px;
	width: 100%;
	box-sizing: border-box;
	background: white;
	color: black;
	padding-right: 42px;

	${props =>
		props.$hide &&
		css`
			display: none;
		`}

	&:focus {
		border-color: ${MAIN_COLOR};
		box-shadow: 0 0 5px ${SHADOW_COLOR};
		outline: none;
	}
`;

export const InputWrapper = styled.div<InputProps>`
	position: relative;
	flex-grow: 1;
	&:before {
		content: '';
		background: url(${HOST + icon}) no-repeat 50% 100%;
		height: 50px;
		position: absolute;
		z-index: 1;
		width: 50px;
		bottom: 4px;
		left: -3px;

		${props =>
			props.$hide &&
			css`
				display: none;
			`}
	}
`;

export const Close = styled.div`
	position: absolute;
	right: 6px;
	top: -2%;
`;
